import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ManualPreadviceTransactionsDeleteDialog from './ManualPreadviceTransactionsDeleteDialog';

class ManualPreadviceTransactionsDelete extends Component {
  render() {
    return (
      <div>
        <ManualPreadviceTransactionsDeleteDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

ManualPreadviceTransactionsDelete.defaultProps = {
  refreshHistories: () => {},
};

ManualPreadviceTransactionsDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default ManualPreadviceTransactionsDelete;
